import { IImageContainerProps, ILazyImageProps, ThemeImageProps, TLazyImageStatus } from '@base/lib/ThemeImage/interface';
import { transImageSrc, getPhoneSrcset, getCdnUrl } from 'base/utils/trans-path';
import { get375RemValue } from 'base/utils/dom-size';
import cn from 'classnames';
import styles from './index.module.less';
import site from 'pro/config/site';
import { isPhone } from 'base/utils/client';
import { theme } from 'pro/config/theme';

export function getProps(props: ThemeImageProps, status: TLazyImageStatus): {
    imageProps: ILazyImageProps;
    containerProps: IImageContainerProps;
} {
    const {
        // calculate
        width: propsWidth,
        height: propsHeight,
        fit = 'fill',
        fixed = false,
        indefinite = false,
        pure = false,
        calcSize = false,
        //img 标签 props
        src: propsSrc,
        alt,
        lazy = true,
        lazyOffset,
        waitLoad,
        // container props
        className,
        style,
        background: propsBackgroud,
        href,
        target,
        absolute = false,
        ...rest
    } = props;

    const src = getCdnUrl(propsSrc);
    const isPure = !href && pure; // 不渲染 container，只渲染 img 标签
    let width = propsWidth;
    const height = propsHeight || propsWidth; // height 默认等于 width
    const background = propsBackgroud === false || status === 'complete' ? void 0 : (propsBackgroud || theme.placeholderColor);

    const transSizeValue = (size?: number | string): string | void => {
        if (typeof size === 'number') {
            return isPhone && theme.useRem ? get375RemValue(size) : `${size}px`;
        }
        return size;
    };

    let containerProps: IImageContainerProps = {
        pure: isPure
    };
    let imageProps: ILazyImageProps = {
        src,
        alt: alt || site?.brand || '',
        lazy,
        lazyOffset,
        waitLoad,
        calcSize,
        width,
        height
    };

    if (isPure) {
        imageProps = {
            ...rest,
            ...imageProps,
            className,
            style: {
                ...style,
                // 图片背景色
                background,
                width: transSizeValue(width),
                height: transSizeValue(height),
            }
        }

    } else {
        imageProps.className = styles[`${fit}-img`];
        containerProps = {
            ...rest,
            ...containerProps,
            className: cn(className, 'g-image', styles.image, { [styles[fit]]: !indefinite }),
            style: {
                ...style,
                // 图片背景色
                background,
            },
            href,
            target,
        };
        if (absolute) {
            containerProps.style.position = 'absolute';
            containerProps.style.top = style?.top || '0';
            containerProps.style.left = style?.left || '0';
        }

        if (typeof width === 'number' && typeof height === 'number') {
            if (fixed) {
                // fixed 模式容器宽高设为固定值
                containerProps.style!.width = transSizeValue(width);
                containerProps.style!.height = transSizeValue(height);
            } else if (!indefinite) {
                // 非 fixed 模式容器以props中的宽高百分比占位（height/width）
                containerProps.style!.paddingBottom = (Math.round((height / width) * 100000) / 1000) + '%';
            }
        }

        if (typeof width === 'string') {
            containerProps.style!.width = width;
        }
        if (typeof height === 'string') {
            containerProps.style!.height = height;
            if (height === 'auto') {
                imageProps.style = {
                    ...imageProps.style,
                    position: 'static',
                    height: 'auto',
                }
            }
        }
    }

    if (typeof width === 'number') {
        const transedSrc = transImageSrc(src, width);
        imageProps.src = transedSrc;

        if (isPhone && status !== 'error' && /\/asset\/width-\d+\//.test(src)) {
            imageProps.sizes = `${Math.ceil((width * 100) / 375)}vw`;
            imageProps.srcSet = getPhoneSrcset(src);
        }
    }

    return {
        containerProps,
        imageProps,
    }
}